export default {
  "brand.name": "AO3阅读器",
  "brand.short": "AO3",

  "nav.home": "首页",
  "nav.features": "功能",
  "nav.screenshots": "截图",
  "nav.platforms": "平台",
  "nav.faq": "常见问题",
  "nav.download": "下载",
  "nav.login": "登录",
  "nav.theme.toLight": "切换到白天模式",
  "nav.theme.toDark": "切换到夜间模式",
  "nav.lang": "EN",

  "hero.badge": "HOME | ARCHIVE OF OUR OWN",
  "hero.title": "你喜爱的每一个故事，都在这一个阅读器里",
  "hero.desc": "AO3阅读器把 Archive of Our Own 带到 Android、iOS、鸿蒙与 Windows —— 标签检索、离线下载，还有为深夜长文准备的阅读视图。",
  "hero.ctaPrimary": "立即下载",
  "hero.ctaSecondary": "查看功能",
  "hero.note": "免费 · Android · iOS · 鸿蒙 · Windows",
  "hero.stat1": "1200万+ 作品",
  "hero.stat2": "50万+ 读者",
  "hero.stat3": "4.9 评分",

  "stats.badge": "深受读者喜爱",
  "stats.works": "作品与同人",
  "stats.readers": "活跃读者",
  "stats.rating": "平均评分",
  "stats.languages": "支持语言",

  "features.badge": "为什么选择AO3阅读器",
  "features.title": "为 Archive 的读者而打造",
  "features.subtitle": "关注你喜爱的同人圈、随时记住读到哪、安静地读下去，你需要的一切都在这里。",
  "features.items.reader.title": "AO3阅读器",
  "features.items.reader.desc": "无干扰阅读模式，字号、行距与翻页皆可调节 —— 这就是为追更而生的AO3阅读器。",
  "features.items.offline.title": "离线书库",
  "features.items.offline.desc": "把完结与连载作品下载下来，飞机上、地铁里、信号中断处都能继续读，书库跟着你走。",
  "features.items.sync.title": "多端同步",
  "features.items.sync.desc": "手机读到一半，电脑上接着读。书签、历史与阅读进度处处跟随你。",
  "features.items.tags.title": "标签与同人圈检索",
  "features.items.tags.desc": "按同人圈、配对、分级、警示与自由标签检索，今晚想看的那个故事，一搜即得。",
  "features.items.night.title": "白天与夜间主题",
  "features.items.night.desc": "白天用温润纸感浅色主题，深夜用护眼深色主题，再长的连载也不累眼。",
  "features.items.platforms.title": "四端一并，一个书库",
  "features.items.platforms.desc": "一个账号、一个书库，覆盖 Android、iOS、鸿蒙与 Windows —— 装一次，任何屏幕都能读。",

  "screenshots.badge": "应用实拍",
  "screenshots.title": "像手工打磨过的阅读器",
  "screenshots.subtitle": "干净的排版、记得你读到哪的书库，还有为凌晨三点准备的夜间主题。",
  "screenshots.items.loading": "启动界面",
  "screenshots.items.home": "AO3首页",
  "screenshots.items.search": "搜索结果",
  "screenshots.items.translate": "翻译控件",
  "screenshots.items.navigation": "侧边导航",

  "platforms.badge": "获取应用",
  "platforms.title": "你手上的每一块屏幕都能用",
  "platforms.subtitle": "选择你的平台。无论点哪个下载按钮，打开的都是同一个快速选择面板。",
  "platforms.android.desc": "手机与平板",
  "platforms.ios.desc": "iPhone 与 iPad",
  "platforms.harmonyos.desc": "鸿蒙手机与平板",
  "platforms.windows.desc": "台式机与笔记本",
  "platforms.download": "下载",
  "platforms.android.caption": "最新版本 · 免费下载",
  "platforms.ios.caption": "全新发布 · 免费安装",
  "platforms.harmonyos.caption": "持续更新 · 免费获取",
  "platforms.windows.caption": "桌面版本 · 免费使用",

  "keywords.badge": "热门搜索",
  "keywords.title": "读者是这样找到我们的",
  "keywords.subtitle": "这些是大家寻找本应用与AO3时搜索最多的词。",

  "faq.badge": "常见疑问",
  "faq.title": "常见问题",
  "faq.subtitle": "读者问得最多的问题，这里给你简短回答。",
  "faq.items.what.q": "AO3阅读器是什么？",
  "faq.items.what.a": "AO3阅读器是一款用来阅读 Archive of Our Own（AO3）上作品的配套应用，由同人爱好者制作与维护，与 OTW 再创作组织没有官方关联。",
  "faq.items.free.q": "AO3阅读器真的免费吗？",
  "faq.items.free.a": "是的。应用在 Android、iOS、鸿蒙与 Windows 上均可免费下载使用，你和故事之间没有任何付费墙。",
  "faq.items.hostError.q": "AO3.CUBEART.CLUB HOST ERROR 怎么解决？",
  "faq.items.hostError.a": "当镜像或第三方主机暂时无法访问时会出现该提示。请更新到最新版本、清理应用内缓存，然后使用本页的官方下载按钮重新安装可用的客户端。",
  "faq.items.platforms.q": "支持哪些平台？",
  "faq.items.platforms.a": "Android、iOS、鸿蒙与 Windows。点击本页任意下载按钮，选择你设备的版本即可。",
  "faq.items.entry.q": "AO3链接入口在哪里？",
  "faq.items.entry.a": "AO3链接入口是从应用内直达AO3的入口。打开应用，点击底部栏的罗盘图标，即可直接进入AO3首页信息流。",

  "cta.badge": "AO3阅读器",
  "cta.title": "让阅读安静下来",
  "cta.desc": "和数十万读者一起，把AO3随身带上。下载AO3阅读器，支持 Android、iOS、鸿蒙与 Windows。",
  "cta.button": "下载AO3阅读器",
  "cta.entry": "AO3链接入口",
  "cta.entryNote": "从应用内直达AO3",

  "modal.title": "下载AO3阅读器",
  "modal.subtitle": "选择你的平台，获取最新版本。",
  "modal.close": "关闭",
  "modal.opening": "正在打开下载…",
  "modal.login": "登录",

  "footer.desc": "AO3阅读器是一款面向 Archive of Our Own 的同人阅读应用。",
  "footer.navTitle": "快速导航",
  "footer.contactTitle": "联系我们",
  "footer.rights": "保留所有权利。",
};